import React from 'react';
import { LayoutContent, LayoutPage, FormRenderer, Form } from 'components';
import { useStoreValue } from 'store';
import { initFormConfig, submitHandler } from 'utils';
import { config } from '_config';
import { useFormInitialValues, useSteps } from '../../hooks';

const FORM_ID = 'extraDetails';
const formConfig = initFormConfig(config.formConfigs[FORM_ID]);

const ExtraDetails = () => {
  const [{ acquisition }] = useStoreValue();
  const initialValues = useFormInitialValues(FORM_ID);
  const { goNext } = useSteps();

  const onSubmit = ({ values, errors }) => {
    function updateStoreAndRedirect() {
      const newAcquisition = {
        ...acquisition,
        extraDetails: { ...values },
      };

      goNext({ storePatch: { acquisition: newAcquisition } });
    }

    submitHandler({ submit: updateStoreAndRedirect, errors });
  };

  return (
    <LayoutPage noSessionTimeout>
      <Form
        id={FORM_ID}
        initialValues={initialValues}
        onSubmit={onSubmit}
        showSaveDraftButton
        saveDraftOnSubmit
        saveDraftOnSessionTimeout
      >
        {formData => {
          return (
            <LayoutContent>
              <FormRenderer config={formConfig} formData={formData} />
            </LayoutContent>
          );
        }}
      </Form>
    </LayoutPage>
  );
};

export { ExtraDetails };
